import { useLocation } from 'react-router';
import OnboardingFooter from '../../components/OnboardingFooter';
import SignIn from '../../views/SignIn';

export default function SignInPage() {
  const location = useLocation();
  const query = new URLSearchParams(location?.search);
  const message = query.get('message');

  return (
    <main className="relative z-10 flex flex-1 flex-col items-center justify-between gap-10 pb-5">
      <div className="flex w-full flex-1 flex-col items-center pt-14 md:pt-16 lg:pt-20">
        <div className="mb-7 flex flex-col items-center gap-2.5 px-10 text-center sm:px-0 md:mb-20 lg:mb-75">
          <img
            src="/assets/images/logo.png"
            alt="logo"
            className="h-85 w-69 md:h-100 md:w-20 lg:h-150 lg:w-121"
          />
          <h2 className="text-brand-byzantine font-bold">Sign In</h2>
          <h5 className="font-inter-variable medium text-brand-byzantine -tracking-sign-up-header-title text-base leading-5 italic md:text-xl md:leading-6 lg:text-2xl lg:leading-7">
            Welcome back to EHS Navigator
          </h5>
        </div>
        <div className="w-full px-25">
          {message && (
            <p className="text-inter-variable text-brand-byzantine bg-indicator-blue mx-auto mb-10 w-full max-w-325 rounded px-1 py-1 text-center text-sm font-medium lg:max-w-465">
              {message}
            </p>
          )}
          <SignIn />
        </div>
      </div>
      <OnboardingFooter />
    </main>
  );
}
